import React from 'react';
import PropTypes from 'prop-types';

import StateSelector from 'apps/age_gate/components/StateSelector';
import BlockedStateWarningText from 'apps/age_gate/components/BlockedStateWarningText';
import AgreeButton from 'apps/age_gate/components/AgreeButton';
import DisagreeButton from 'apps/age_gate/components/DisagreeButton';

export default class BodyContainer extends React.Component {
  static propTypes = {
    configurations: PropTypes.object.isRequired,
    ageGateUIPolicy: PropTypes.object,
    ageGateTPActions: PropTypes.object,
    callbacks: PropTypes.objectOf(PropTypes.func),
  };

  constructor(props) {
    super(props);

    const { ageGateUIPolicy } = props;

    this.state = { selectedState: ageGateUIPolicy.getInitialGeoState() };
  }

  handleStateSelectionChange = selected => {
    if (selected) {
      this.setState({ selectedState: selected });
    }
  };

  stateSelectorComponent = () => {
    const {
      configurations: { selector },
    } = this.props;
    const { selectedState } = this.state;
    const { handleStateSelectionChange } = this;

    return (
      selector && (
        <StateSelector
          selector={selector}
          selectedState={selectedState}
          callback={handleStateSelectionChange}
        />
      )
    );
  };

  blockedStateWarningTextComponent = () => {
    const { selectedState } = this.state;
    const { ageGateUIPolicy } = this.props;

    return (
      ageGateUIPolicy.shouldShowBlockedStateWarning(selectedState) && (
        <BlockedStateWarningText stateLabel={selectedState.label} />
      )
    );
  };

  handleRouteToLocatorButtonTrigger = () => {
    const {
      ageGateTPActions,
      callbacks: { onAgreeButtonClick },
    } = this.props;

    ageGateTPActions.setRouteToLocatorCookie();
    ageGateTPActions.routeToLocatorUrl();

    onAgreeButtonClick();
  };

  handleAgreeButtonTrigger = () => {
    const {
      ageGateUIPolicy,
      ageGateTPActions,
      callbacks: { onAgreeButtonClick },
    } = this.props;
    const { selectedState } = this.state;

    ageGateTPActions.setCookie(ageGateUIPolicy);

    (ageGateUIPolicy.isTriggerStatePricingEnabled()
      ? ageGateTPActions.statePricing(selectedState.value)
      : Promise.resolve()
    ).then(onAgreeButtonClick);
  };

  decideAgreeButtonProps = () => {
    const { ageGateUIPolicy } = this.props;
    const { selectedState } = this.state;

    if (ageGateUIPolicy.shouldShowRouteToLocatorButton(selectedState)) {
      return {
        messageId: 'ROUTE_TO_LOCATOR_TEXT',
        onClick: () => this.handleRouteToLocatorButtonTrigger(),
        disabled: false,
      };
    }

    return {
      messageId: 'AGREE_TEXT',
      onClick: () => this.handleAgreeButtonTrigger(),
      disabled: ageGateUIPolicy.shouldDisableAgreeButton(selectedState),
    };
  };

  agreeButtonComponent = () => {
    const {
      configurations: { minimum_age, agree },
    } = this.props;
    const { selectedState } = this.state;

    return (
      agree && (
        <AgreeButton
          selectedState={selectedState}
          minimumAge={minimum_age}
          {...this.decideAgreeButtonProps()}
        />
      )
    );
  };

  disagreeButtonComponent = () => {
    const {
      configurations: { minimum_age, disagree },
    } = this.props;

    return disagree && <DisagreeButton minimum_age={minimum_age} />;
  };

  render() {
    return (
      <div id="age-gate-body-container">
        <div className="age-gate__selector-subsection">
          {this.stateSelectorComponent()}
          {this.blockedStateWarningTextComponent()}
        </div>
        <div className="age-gate__buttons-subsection">
          {this.agreeButtonComponent()}
          {this.disagreeButtonComponent()}
        </div>
      </div>
    );
  }
}
